import React, { useState, useEffect } from "react";
import { getSensorDataByContainerIdWithFiltersFor3DView } from "../../../../api/sensorApi";
import { getAllDeviceCoordinatesByContainerId } from "../../../../api/locationApi";
import HeatmapThreeD from "../../../Shared/HeatmapThreeD/HeatmapThreeD";
import CustomDateHourPicker from "../../../Shared/CustomDateHourPicker/CustomDateHourPicker";
import { toast } from "react-toastify";
import "../ContainerMoreInfoPage.scss";
import LoadingAnimation from "../../../Shared/LoadingAnimation/LoadingAnimation";

const ContainerThreeDView = ({ containerId, t }) => {
  const [sensorData, setSensorData] = useState([]);
  const [deviceCoordinates, setDeviceCoordinates] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSensorData = async (date, hour) => {
    try {
      setLoading(true);

      // Default to current date and hour if not provided
      const now = new Date();
      const targetDate = date ? new Date(date) : now;

      // Ensure hour is a valid number between 0-23
      const validHour =
        hour !== undefined && hour !== null && !isNaN(hour)
          ? Math.max(0, Math.min(23, parseInt(hour)))
          : now.getHours();

      //console.log(`Using hour: ${validHour}`);

      try {
        // Create a date in local time with the selected date and hour
        const localDateTime = new Date(targetDate);
        localDateTime.setHours(validHour, 0, 0, 0);

        // Validate that localDateTime is valid before proceeding
        if (isNaN(localDateTime.getTime())) {
          throw new Error("Invalid date/time combination");
        }

        // Get UTC hour for API parameter
        const targetHour = localDateTime.getUTCHours();

        // Create start and end time in UTC
        const startDateTime = new Date(localDateTime);
        const endDateTime = new Date(startDateTime);
        endDateTime.setHours(startDateTime.getHours() + 1); // One hour range

        const formattedStartDate = startDateTime.toISOString();
        const formattedEndDate = endDateTime.toISOString();

        const params = {
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          hour: targetHour,
        };

        const response = await getSensorDataByContainerIdWithFiltersFor3DView(
          containerId,
          params
        );

        setSensorData(response);

        // Fetch device coordinates if not already loaded
        if (!deviceCoordinates.length) {
          fetchDeviceCoordinates();
        }
      } catch (dateError) {
        console.error("Date processing error:", dateError);
        toast.error("Érvénytelen dátum vagy időpont");
      }
    } catch (error) {
      console.error("Error fetching sensor data:", error);
      toast.error("Nem sikerült lekérni a szenzor adatokat");
    } finally {
      setLoading(false);
    }
  };

  const fetchDeviceCoordinates = async () => {
    try {
      const response = await getAllDeviceCoordinatesByContainerId(containerId);
      setDeviceCoordinates(response);
    } catch (error) {
      console.error("Error fetching device coordinates:", error);
      toast.error("Nem sikerült lekérni az eszköz koordinátákat");
    }
  };

  // Handle date and hour change from the date picker
  const handleDateHourChange = (date, hour) => {
    fetchSensorData(date, hour);
  };

  // Initial data load
  useEffect(() => {
    if (containerId) {
      fetchDeviceCoordinates();
      fetchSensorData();
    }
  }, [containerId]);

  return (
    //
    <div className="c3dv">
      <div className="date-selector-container">
        <CustomDateHourPicker onDateHourChange={handleDateHourChange} />
      </div>

      <div className="visualization-container">
        {loading ? (
          <LoadingAnimation />
        ) : (
          <HeatmapThreeD
            sensorData={sensorData}
            deviceCoordinates={deviceCoordinates}
          />
        )}
      </div>
    </div>
  );
};

export default ContainerThreeDView;
